<template>
  <view class="container">
    <view class="clip-content" wx:class="{{clipContentClassName}}">
      <view class="upload-container choose-gallery" wx:class="{{chooseGalleryClassName}}">
        <es-navbar title="人证核验"></es-navbar>
        <view class="es-clip-tips">
          <view class="es-clip-title">温馨提示</view>
          <view class="es-clip-content"> 请上传一张五官清晰的正面照片</view>
        </view>
        <view class="es-clip-image">
          <image
            src="https://pt-starimg.didistatic.com/static/starimg/img/S04vGSwGcn1644303137714.png"
            mode="scaleToFill"
            class="es-clip-image-mode"
          ></image>
        </view>
        <!-- <view class="upload-pretty button-three-dimen">
           <input
            wx:ref="uploadFile"
            style="display: none;"
            name="image"
            type="file"
            class="es-input-upload"
            accept="image/*"
            mutiple="mutiple"
            bindinput="fileChange"
          />上传照片
        </view> -->
        <view class="upload-pretty">
          <view class="es-chooseImages-input" bindtap="chooseImages">上传照片</view>
        </view>
      </view>
      <view class="es-img-clip"><view class="img-clip"> </view></view>
      <view class="clip-action nav-bar nav-bar-tab" wx:class="{{clipActionClassName}}">
        <view class="es-nav-tip-text">
          3:4
        </view>
        <view class="tab-item es-btn-reload" id="btn-reload" bindtap="btnReload">
          <view class="mui-icon mui-icon-arrowleft tab-icon ">
            <image
              class="es-icon-arrowleft"
              src="https://pt-starimg.didistatic.com/static/starimg/img/ZZEsmc940p1642476352407.png"
            ></image>
          </view>
          <!-- <view class="tab-label">取消</view> -->
        </view>
        <!-- <view class="tab-item " id="btn-rotate-anticlockwise" bindtap="btnRotateAnticlockwise">
          <view class="mui-icon mui-icon-refreshempty tab-icon rotate90"></view>
          <view class="tab-label">逆时针旋转</view>
        </view> -->
        <view
          class="tab-item btn-rotate-clockwise"
          id="btn-rotate-clockwise"
          bindtap="btnRotateAnticlockwise"
        >
          <view class="mui-icon mui-icon-refreshempty tab-icon">
            <image
              class="es-roate-clockwise-icon"
              src="https://pt-starimg.didistatic.com/static/starimg/img/alQ28bxblq1644324118136.png"
            ></image>
          </view>
          <!-- <view class="tab-label ">顺时针旋转</view> -->
        </view>

        <view class="tab-item es-btn-verify" id="btn-verify" bindtap="btnVerify">
          <view class="mui-icon mui-icon-checkmarkempty tab-icon">
            <image
              class="es-icon-arrowleft"
              src="https://pt-starimg.didistatic.com/static/starimg/img/tBOkzhgQan1642476892674.png"
            ></image>
          </view>
        </view>
      </view>
    </view>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { getStorage } from '@/utils/storage'
  import EXIF from './exif.js'
  import choose from './files'
  // import filesUpload from './files'
  import ImageClip from './image-clip'
  import getImg from './getImg'
  // const FileInput = FileInputs()
  createComponent({
    data: {
      cropImage: null,
      targetImg: '',
      inputValue: '',
      targetImgCamera: '',
      chooseGallery: '',
      chooseCamera: '',
      clipContent: '',
      clipAction: '',
      showContent: '',
      showImg: null,
      chooseGalleryBlock: false,
      chooseCameraBlock: false,
      clipActionBlock: true,
      clipContentBlock: false,
      showContentBlock: true,
      isXiaomiBrowser: false
    },

    computed: {
      chooseGalleryClassName() {
        const { chooseGalleryBlock } = this
        return {
          hidden: chooseGalleryBlock
        }
      },
      imgClipClassName() {
        const { chooseGalleryBlock } = this
        return {
          hiddenBox: !chooseGalleryBlock
        }
      },
      clipActionClassName() {
        const { clipActionBlock } = this
        return {
          hidden: clipActionBlock
        }
      },
      clipContentClassName() {
        const { clipContentBlock } = this
        return {
          hidden: clipContentBlock
        }
      },
      showContentClassName() {
        const { showContentBlock } = this
        return {
          hidden: showContentBlock
        }
      }
    },

    watch: {},

    methods: {
      async chooseImages() {
        if (this.isXiaomiBrowser) {
          mpx.showToast({
            title: '请更换浏览器或重新点击上传', //提示的内容,
            icon: 'error', //图标,
            duration: 2000 //延迟时间,
          })
        } else {
          let { files, urls } = await choose()
          this.loadImg(urls[0])
        }
      },
      fileChange(e) {
        const _this = this
        let files = e.target.files
        let reader = new window.FileReader()
        reader.readAsDataURL(files[0]) // 如果多选 - 这里处理
        reader.onload = function (e) {
          // 读取到的图片 base64 数据编码 将此编码字符串传给后台即可
          let imgBase64Code = e.target.result
          // // 截取头部信息。统一 jpeg 显示
          // imgBase64Code = imgBase64Code.replace(/^data:image\/\w+;base64,/, '')
          if (imgBase64Code && imgBase64Code.indexOf('data:base64,') !== -1) {
            // 去除旧有的错误头部
            imgBase64Code = imgBase64Code.replace('data:base64,', '')
            const dataType = ''
            // 文件名字
            const name = file.name
            if (name && name.toLowerCase().indexOf('.jpg') !== -1) {
              // jpeg
              dataType = 'image/jpeg'
            } else if (name && name.toLowerCase().indexOf('.png') !== -1) {
              // png
              dataType = 'image/png'
            }
            imgBase64Code = 'data:' + dataType + ';base64,' + imgBase64Code
          }

          _this.loadImg(imgBase64Code)
        }
        reader.onerror = function (err) {
          mpx.showToast({
            title: err, //提示的内容,
            icon: 'error', //图标,
            duration: 2000 //延迟时间,
          })
        }
      },
      initParams() {
        //获取浏览器的userAgent,并转化为小写
        const ua = navigator.userAgent.toLowerCase()

        //判断是否是苹果手机，是则是true
        const isIos = ua.indexOf('iphone') != -1 || ua.indexOf('ipad') != -1
        const isQQ = ua.indexOf('mqqbrowser') > -1 && ua.indexOf(' qq') < 0 //qq浏览器
        const isXiaomi = ua.indexOf('xiaomi/miuibrowser/14.4.18') > -1
        // if (isIos) {
        //   const files = document.querySelectorAll('input[type=file]')
        //   if (files) {
        //     files.forEach(item => {
        //       item.removeAttribute('capture')
        //     })
        //   }
        // }
        if (isXiaomi) {
          this.isXiaomiBrowser = true
        }
      },
      btnReload() {
        // 销毁当前的裁剪对象
        this.cropImage && this.cropImage.destroy()
        this.changeImgClipShow(false)
      },
      // btnReload() {
      //   this.changeContent(false)
      // },
      btnSave() {
        this.upload(function () {
          mpx.showToast({
            title: '上传成功'
            // icon: 'error'
          })
        })
      },
      btnDetail() {
        this.showImgDataLen(this.imgData)
      },
      btnMaxrect() {
        if (!this.cropImage) {
          this.tips('请选择图片')
          return
        }
        this.cropImage.resetClipRect()
      },
      btnRotateAnticlockwise() {
        if (!this.cropImage) {
          this.tips('请选择图片')
          return
        }
        this.cropImage.rotate(false)
      },
      btnRotateClockwise() {
        if (!this.cropImage) {
          // this.tips('请选择图片')
          mpx.showToast({
            title: '请选择图片'
            // icon: 'error'
          })
          return
        }
        this.cropImage.rotate(true)
      },
      btnVerify() {
        const _this = this
        // this.changeContent(false)
        if (!this.cropImage) {
          mpx.showToast({
            title: '请选择图片'
          })
          return
        }

        this.cropImage.clip(false) // 裁剪图像，根据当前的裁剪框进行裁剪
        // 获取已裁剪的图像
        this.imgData = this.cropImage.getClipImgData()
        // this.changeContent(false)
        this.recognizeImg(
          function () {
            _this.changeContent(false) //  true
            // 优化了一下
            getImg({ url: _this.imgData, width: 150, height: 200 })
              .then(function (ba64) {
                if (ba64) {
                  _this.triggerEvent('clipImg', {
                    imageData: ba64
                  })
                } else {
                  _this.triggerEvent('clipImg', {
                    imageData: _this.imgData
                  })
                }
              })
              .catch(function (err) {
                console.error(err)
              })

            _this.btnReload() // 跳转前 关闭
          },
          function (error) {
            _this.tips(JSON.stringify(error), true)
          }
        )
      },
      btnBack() {
        this.changeContent(false)
      },
      initListeners() {},
      initImgClip() {
        // const _this = this
        // new FileInput({
        //   container: '#targetImg',
        //   isMulti: false,
        //   type: 'Image_Camera',
        //   success: function(b64, file, detail) {
        //     console.log(b64, 'b64b64b64b64b64b64b64b64')
        //     _this.loadImg(b64)
        //   },
        //   error: function(error) {
        //     console.error(error)
        //   }
        // })
      },
      loadImg(b64) {
        this.changeImgClipShow(true)
        const img = new Image()
        img.src = b64
        const _this = this
        img.onload = function () {
          EXIF.getData(img, function () {
            const orientation = EXIF.getTag(this, 'Orientation')
            // 如果一个容器需要重新生成裁剪对象，一定要先销毁以前的
            _this.cropImage && _this.cropImage.destroy()
            _this.cropImage = new ImageClip({
              container: '.img-clip',
              containerParent: '.es-img-clip',
              img,
              width: 150,
              height: 200,
              // 0代表按下才显示，1恒显示，-1不显示
              sizeTipsStyle: 0,
              // 为1一般是屏幕像素x2这个宽高
              // 最终的大小为：屏幕像素*屏幕像素比（手机中一般为2）*compressScaleRatio
              compressScaleRatio: 1.1,
              // iphone中是否继续放大：x*iphoneFixedRatio
              // 最好compressScaleRatio*iphoneFixedRatio不要超过2
              iphoneFixedRatio: 1.8,
              // 减去顶部间距，底部bar,以及显示间距
              maxCssHeight: window.innerHeight,
              // 放大镜捕获的图像半径
              captureRadius: 30,
              // 是否采用原图像素（不会压缩）
              isUseOriginSize: false,
              // 增加最大宽度，增加后最大不会超过这个宽度
              maxWidth: 0,
              // 是否固定框高，优先级最大，设置后其余所有系数都无用直接使用这个固定的宽，高度自适应
              forceWidth: 0,
              // 同上，但是一般不建议设置，因为很可能会改变宽高比导致拉升，特殊场景下使用
              forceHeight: 0,
              // 压缩质量
              quality: 0.92,
              mime: 'image/jpeg'
            })
            // 6代表图片需要顺时针修复（默认逆时针处理了，所以需要顺过来修复）
            switch (orientation) {
              case 6:
                _this.cropImage.rotate(true)
                break
              default:
                break
            }
          })
        }
      },
      resizeShowImg(b64) {
        const img = new Image()
        img.src = b64
        // img.onload = this.showImgOnload
      },
      // showImgOnload() {
      //   // 必须用一个新的图片加载，否则如果只用showImg的话永远都是第1张
      //   // margin的话由于有样式，所以自动控制了
      //   const width = this.width
      //   const height = this.height
      //   const wPerH = width / height
      //   const MAX_WIDTH = Math.min(window.innerWidth, width)
      //   const MAX_HEIGHT = Math.min(window.innerHeight - 50 - 100, height)
      //   const legalWidth = MAX_WIDTH
      //   const legalHeight = legalWidth / wPerH

      //   if (MAX_WIDTH && legalWidth > MAX_WIDTH) {
      //     legalWidth = MAX_WIDTH
      //     legalHeight = legalWidth / wPerH
      //   }
      //   if (MAX_HEIGHT && legalHeight > MAX_HEIGHT) {
      //     legalHeight = MAX_HEIGHT
      //     legalWidth = legalHeight * wPerH
      //   }

      //   const marginTop = (window.innerHeight - 50 - legalHeight) / 2

      //   this.showImg.style.marginTop = marginTop + 'px'
      //   this.showImg.style.width = legalWidth + 'px'
      //   this.showImg.style.height = legalHeight + 'px'
      // },
      changeImgClipShow(isClip) {
        if (isClip) {
          this.chooseGalleryBlock = true
          this.chooseCameraBlock = true
          this.clipActionBlock = false
        } else {
          this.chooseGalleryBlock = false
          this.chooseCameraBlock = false
          this.clipActionBlock = true

          // 需要改变input，否则下一次无法change
          // this.targetImg.value = ''
          this.inputValue = ''
        }
      },
      showImgDataLen(imgData) {
        const len = imgData.length
        let sizeStr = len + 'B'

        if (len > 1024 * 1024) {
          sizeStr = Math.round(len / (1024 * 1024)).toString() + 'MB'
        } else if (len > 1024) {
          sizeStr = Math.round(len / 1024).toString() + 'KB'
        }

        this.tips('处理后大小：' + sizeStr)
      },
      changeContent(isShowContent) {
        console.log(isShowContent, 'isShowContentisShowContent')
        if (isShowContent) {
          this.showContentBlock = false
          this.clipContentBlock = true
          this.resizeShowImg(this.imgData)
          this.showImg = this.imgData
        } else {
          this.showContentBlock = true
          this.clipContentBlock = false
        }
      },
      b64ToBlob(urlData) {
        const arr = urlData.split(',')
        const mime = arr[0].match(/:(.*?);/)[1] || 'image/png'
        // 去掉url的头，并转化为byte
        const bytes = window.atob(arr[1])

        // 处理异常,将ascii码小于0的转换为大于0
        const ab = new ArrayBuffer(bytes.length)
        // 生成视图（直接针对内存）：8位无符号整数，长度1个字节
        const ia = new Uint8Array(ab)
        for (let i = 0; i < bytes.length; i++) {
          ia[i] = bytes.charCodeAt(i)
        }

        return new Blob([ab], {
          type: mime
        })
      },
      downloadFile(content) {
        // Convert image to 'octet-stream' (Just a download, really)
        const imageObj = content.replace('image/jpeg', 'image/octet-stream')
        window.location.href = imageObj
      },
      recognizeImg(success, error) {
        // 里面正常有：裁边，摆正，梯形矫正，锐化等算法操作
        success()
      },
      upload(success, error) {
        success()
      }
    },

    beforeCreate() {},

    created() {},

    mounted() {
      this.initParams()
      this.initListeners()
      this.initImgClip()
    },

    destroyed() {}
  })
</script>

<style lang="stylus" src='./clip.styl'></style>
<style lang="stylus">
  @import '~@/mixins/stylus/color.styl'

  .es-chooseImages-input
    width 190px
    border-radius 0.5em
    color #ffffff
    border none
    background #1473ff
    padding 0
    margin 0 auto
    text-align center
    padding 13px 0px 15px 0px
    font-size 16px
  .black
    height 100%
    background #000000
  .es-input-upload
    width 200px
    height 60px
  .hidden
    display none !important
  .es-clip-image
    display flex
    justify-content center
    padding 20px 0
  .es-clip-image-mode
    width 172px
    height 172px
  .es-img-clip
    position absolute
    left 0
    top 0
    margin 0 auto
    padding 0
    width 100%
    height 100%
    background #000000
    z-index 1
  .img-clip
    position relative
    width 97%
    margin 0 auto
    padding 0
    background #000000
    z-index 1
  .img-clip canvas
    display block
  .img-clip-b1
    width 100%
    height 1px
    background rgba(255, 255, 255, 0.6)
  .img-clip .magnifier
    position absolute
    top -90px
    right 0
    /**
     * 显示的值，真实的宽高内部会设置
     */
    width 80px
    height 80px
    border-radius 50%
    border 2px solid #ffffff
  .img-clip .clip-hidden
    display none
  .img-clip .clip-rect
    position absolute
    border 1px solid rgba(255, 255, 255, 0.6)
    top 10px
    left 10px
    width 100px
    height 100px
    cursor move
    box-shadow 0 0px 2px rgba(0, 0, 0, 0.4)
    min-width 45px !important
  .img-clip-reat-left
    width 0px
    height 100%
    position absolute
    left 0px
    top 0px
    display none
    // border-top 1px solid rgba(255, 255, 255, 0.6)
    border-left 1px solid rgba(255, 255, 255, 0.6)
  .img-clip .clip-rect .clip-tips
    position absolute
    top -40px
    left 0
    padding 5px
    font-size 13px
    background-color $train-color-333
    border-radius 5px
    color #ffffff
  .img-clip .clip-rect-horn
    position absolute
    display block
    // background-color rgba(222, 60, 80, 0.7)
    // border-radius 50%
    width 30px
    height 30px
    // background #000
  .img-clip .clip-rect-horn:after
    content ' '
    position absolute
    width 25px
    height 2px
    background #ffffff
    top -3px
    left -3px
  .img-clip .clip-rect-horn:before
    content ' '
    position absolute
    width 2px
    height 25px
    background #ffffff
    top -3px
    left -3px
  .img-clip .horn-n
    top -10px
    left 50%
    margin-left -10px
    cursor n-resize
    display none
  .img-clip .horn-s
    bottom -10px
    left 50%
    margin-left -10px
    cursor s-resize
    display none
  .img-clip .horn-w
    top 50%
    left -10px
    margin-top -10px
    cursor w-resize
    display none
  .img-clip .horn-e
    top 50%
    right -10px
    margin-top -10px
    cursor e-resize
    display none
  .img-clip .horn-nw
    top 0px
    left 0px
    cursor nw-resize
  .img-clip .horn-ne
    top 0px
    right 0px
    cursor ne-resize
  .img-clip .horn-ne:after
    left 7px
    top -3px
  .img-clip .horn-ne:before
    left 30px
    top -2px
  .img-clip .horn-sw
    bottom 0px
    left 0px
    cursor sw-resize
  .img-clip .horn-sw:after
    left -3px
    top 31px
  .img-clip .horn-sw:before
    left -3px
    top 6px
  .img-clip .horn-se
    bottom -10px
    right -10px
    cursor se-resize
  .img-clip .horn-se:after
    left -3px
    top 21px
  .img-clip .horn-se:before
    left 20px
    top -3px
  .es-clip-tips
    width 252px
    margin 0 auto
    text-align center
    padding-top 30px
    font-size 16px
  .upload-container
    position relative
    height 100%
    z-index 2
    background #ffffff
  .hiddenBox
    display none
  .clip-tips-b1
    position absolute
    width 100%
    height 1px
    background rgba(255, 255, 255, 0.2)
    top 33.3%
  .clip-tips-b2
    position absolute
    width 100%
    height 1px
    background rgba(255, 255, 255, 0.2)
    top 66.3%
  .clip-tips-b3
    position absolute
    width 1px
    height 100%
    top 0
    background rgba(255, 255, 255, 0.2)
    left 33.3%
  .clip-tips-b4
    position absolute
    width 1px
    height 100%
    top 0
    background rgba(255, 255, 255, 0.2)
    left 66.3%
  .btn-rotate-clockwise
    width 32px
    height 32px
    position absolute
    right 50%
    top 0px
    margin-right -16px
  .es-roate-clockwise-icon
    width 32px
    height 32px
  .es-btn-reload
    width 40px
    height 40px
    position absolute
    left 30px
    top 0px
  .es-btn-verify
    width 40px
    height 40px
    position absolute
    right 30px
    top -2px
  .es-icon-arrowleft
    width 40px
    height 40px
  .es-nav-tip-text
    position absolute
    left 50%
    top -40px
    color #ffffff
    font-size 16px
    margin-left -10px
    font-family sans-serif
  .es-clip-title
    font-size 18px
    font-weight bold
  .es-clip-content
    font-size 16px
</style>
<script name='json'>
  module.exports = {
    // navigationBarTitleText: '裁剪图片',
    component: true,
    usingComponents: {
    }
  }
</script>

